// import G02 from "./residences/G02";
import P01 from "./residences/P01";
import G05 from "./residences/G05";
import G04 from "./residences/G04";
import F05 from "./residences/F05";
// import Dummy from "./residences/Dummy";

export default [P01, G05, G04, F05];
